export default __webpack_public_path__ + "static/media/testimonial-2.5698dda1.png";